import isValidProp from '@emotion/is-prop-valid';

const customHandlers = new Set([
  'onPress',
  'onPressStart',
  'onPressEnd',
  'onPressChange',
  'onPressUp',
  'onHoverStart',
  'onHoverEnd',
  'onHoverChange',
  'onFocusChange',
  'label',
]);

export function isValidButtonProp(prop: string) {
  return isValidProp(prop) && !customHandlers.has(prop);
}
